import React from 'react';
import {CardActions, CreateButton, Datagrid, Filter, List, TextField, TextInput} from 'react-admin';
import {BillAuthStatusField, DateTimeField, DownloadFileContentButton} from "../../components";
import DownloadFileResultButton from "../../components/DownloadFileResultButton";

const IntroductionFileFilter = (props) => (
    <Filter {...props}>
        <TextInput label="ra.action.search" source="q" alwaysOn/>
    </Filter>
);

const PostActions = ({
                         bulkActions,
                         basePath,
                         currentSort,
                         displayedFilters,
                         exporter,
                         filters,
                         filterValues,
                         onUnselectItems,
                         resource,
                         selectedIds,
                         showFilter,
                         total
                     }) => (
    <CardActions>
        {bulkActions && React.cloneElement(bulkActions, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
        })}
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        })}
        <CreateButton basePath={basePath}/>
    </CardActions>
);
export const MessageBatchList = props => (
    <List filters={<IntroductionFileFilter/>} {...props} exporter={false} actions={<PostActions/>}>
        <Datagrid>
            <TextField source="id"/>
            <TextField source="title"/>
            <TextField source="description"/>
            <BillAuthStatusField source="authStatus"/>
            <TextField source="lastUpdatedBy"/>
            <DateTimeField source="lastUpdatedOn" format="DD/MM/YYYY HH:mm"/>
            <DownloadFileContentButton extension={".zip"}/>
            <DownloadFileResultButton/>
        </Datagrid>
    </List>
);

export default MessageBatchList
